
import React from 'react';
import styles from '../landing.module.scss';
import { FaArrowRight, FaChartLine, FaSearch, FaGamepad, FaGlobe } from 'react-icons/fa';
import { fetchCategories, fetchBlogPostsByCategory } from '../../../helpers/blogApi';
import { Link } from 'react-router-dom';

const CaseStudies = () => {
    const [caseStudiesData, setCaseStudiesData] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const icons = [FaChartLine, FaSearch, FaGamepad, FaGlobe];

    React.useEffect(() => {
        const fetchData = async () => {
            try {
                // 1. Fetch Categories
                const catResponse = await fetchCategories();
                const categories = catResponse.data.slice(0, 4); // Limit to 4 for the grid

                // 2. Fetch latest posts for each category
                const promises = categories.map(async (cat, index) => {
                    // Strapi v5 flat or v4 attributes
                    const catData = cat.attributes || cat;
                    const catSlug = catData.slug;
                    const catName = catData.name;

                    // Fetch 2 latest posts for this category
                    // We can use fetchBlogPostsByCategory with a small page size if we modified it to accept options
                    // But current helper doesn't support pagination options well in the helper signature, 
                    // so let's use the helper and slice the result or we might need to update helper if we care about over-fetching.
                    // The current fetchBlogPostsByCategory fetches default pageSize (usually 25 or 10).
                    // We'll just slice the result client side for now to minimal impact.

                    const postsResponse = await fetchBlogPostsByCategory(catSlug);
                    const posts = postsResponse.data.slice(0, 2).map(post => {
                        const pData = post.attributes || post;
                        return {
                            text: pData.title,
                            url: `/blog/${pData.slug}`
                        };
                    });

                    return {
                        title: catName,
                        icon: icons[index % icons.length],
                        links: posts
                    };
                });

                const results = await Promise.all(promises);
                setCaseStudiesData(results);
            } catch (error) {
                console.error("Error fetching case studies data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    if (loading) {
        return (
            <section className={styles.caseStudiesSection}>
                <div className={styles.container}>
                    <div className={styles.sectionHeader}>
                        <h2>Case Studies</h2>
                        <p>Loading topics...</p>
                    </div>
                </div>
            </section>
        );
    }

    if (caseStudiesData.length === 0) {
        return null; // Or some empty state
    }

    return (
        <section className={styles.caseStudiesSection}>
            <div className={styles.container}>
                <div className={styles.sectionHeader}>
                    <h2>Case Studies</h2>
                    <p>Learn how to get the most out of KeyQuest with real-world examples.</p>
                </div>

                <div className={styles.caseStudiesGrid}>
                    {caseStudiesData.map((item, index) => (
                        <div key={index} className={styles.caseStudyCard}>
                            <h3>{item.title}</h3>
                            <div className={styles.linksList}>
                                {item.links.length > 0 ? (
                                    item.links.map((link, idx) => (
                                        <Link key={idx} to={link.url} className={styles.cardLink}>
                                            <item.icon className={styles.linkIcon} />
                                            <span>{link.text}</span>
                                            <FaArrowRight className={styles.arrowIcon} size={12} />
                                        </Link>
                                    ))
                                ) : (
                                    <div className={styles.cardLink}>
                                        <span>No articles yet</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default CaseStudies;
